<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Create New Press Release</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Press Title"
                class="mb-0"
                type="text"
                required
                v-model="pressTitle"
                horizontal
                @input="handlePressTitle"
                placeholder="Press Title"
              />
            </CCol>
            <h5>
              <p v-if="alertPressTitle" class="alert-press">Max 120 chars</p>
            </h5>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Press URL"
                class="mb-0"
                type="text"
                v-model="pressRelease.press_release_url"
                horizontal
                @input="handleURL"
                placeholder="Press URL"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInputFile
                label="Image"
                horizontal
                type="file"
                @change="handleImage"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <h5>
                <p v-if="alertPressImage" class="alert-image">
                  Size images: 640 x 480 and max images: 500 Kb
                </p>
              </h5>
              <img class="image-ilustrasi" id="myImg" v-if="url" :src="url" />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CTextarea
                label="Content"
                class="mb-0"
                type="text"
                @input="handleNote"
                v-model="pressRelease.press_release_content"
                required
                horizontal
                placeholder
              />
            </CCol>
            <h5>
              <p v-if="alertPressNote" class="alert-press">Max 1000 chars</p>
            </h5>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                color="success"
                class="float-right ml-2"
                @click="updatePressRelease"
                >Submit</CButton
              >
              <CButton
                color="danger"
                class="float-right"
                @click="deletePressRelease"
                >Delete</CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import jwt from "jsonwebtoken";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "PressReleaseEdit",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.usersOpened = from.fullPath.includes("usercreate");
    });
  },
  data() {
    return {
      pressRelease: {},
      pressTitle: "",
      delete: "true",
      alertPressTitle: false,
      alertPressImage: false,
      alertPressNote: false,
      sizeImage: 0,
      sizeNote: 0,
      widthImage: 0,
      heightImage: 0,
      url: null,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    this.authentication();
    this.getDataByID();
  },
  computed: {},
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "MARKETING" ||
        data.account_group === "COMMUNITY" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/about-us/press-release" });
    },
    handlePressTitle(event) {
      this.pressTitle = event;
      if (event.length > 120) {
        this.alertPressTitle = true;
      } else {
        this.pressTitle = event;
        this.alertPressTitle = false;
      }
    },
    handleURL(event) {
      this.pressRelease.press_release_url = event;
    },
    handleImage(event) {
      var sizeFile = event[0].size / 1024 / 1024;
      this.sizeImage = sizeFile;

      if (sizeFile > 0.5) {
        this.alertPressImage = true;
      } else {
        this.alertPressImage = false;
      }

      let img = new Image();
      img.src = window.URL.createObjectURL(event[0]);
      img.onload = () => {
        if (img.width > 640) {
          this.alertPressImage = true;
        } else {
          this.alertPressImage = false;
        }

        if (img.height > 480) {
          this.alertPressImage = true;
        } else {
          this.alertPressImage = false;
        }
        this.widthImage = img.width;
        this.heightImage = img.height;
      };

      const file = event[0];
      this.url = URL.createObjectURL(file);
      this.pressRelease.attachment_press_release = file;
    },
    handleNote(event) {
      this.pressRelease.press_release_content = event;
      if (this.pressRelease.press_release_content.length > 1000) {
        this.alertPressNote = true;
      } else {
        this.alertPressNote = false;
      }
      this.sizeNote = event.length;
    },
    getDataByID() {
      let pressReleaseID = this.$route.params.id;
      axios
        .get(`${this.domain}/v1/press_release/${pressReleaseID}`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.pressRelease = response.data;
          this.pressTitle = this.pressRelease.press_release_title;
          this.url = this.pressRelease.attachment_press_release;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    updatePressRelease() {
      this.pressRelease.press_title = this.pressTitle;
      if (
        this.pressRelease.press_title.length > 120 ||
        this.sizeImage > 0.5 ||
        this.widthImage > 640 ||
        this.heightImage > 480 ||
        this.sizeNote > 1000
      ) {
        Swal.fire({
          icon: "error",
          title: "Invalid input",
        });
      } else {
        let formData = new FormData();
        formData.append(
          "press_release_title",
          this.pressRelease.press_release_title
        );
        formData.append(
          "press_release_url",
          this.pressRelease.press_release_url
        );
        formData.append(
          "attachment_press_release",
          this.pressRelease.attachment_press_release
        );
        formData.append(
          "press_release_content",
          this.pressRelease.press_release_content
        );
        let pressReleaseID = this.$route.params.id;

        axios
          .put(`${this.domain}/v1/press_release/${pressReleaseID}`, formData, {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            Swal.fire({
              icon: "success",
              title: `Press Release Data Updated`,
              showConfirmButton: false,
              timer: 2000,
            });
            this.items = response.data;
            this.$router.push({ path: `/about-us/press-release` });
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response.data.message.id,
            });
            console.log(err);
          });
      }
    },
    deletePressRelease() {
      let formData = new FormData();
      formData.append(
        "press_release_title",
        this.pressRelease.press_release_title
      );
      formData.append("press_release_url", this.pressRelease.press_release_url);
      formData.append(
        "attachment_press_release",
        this.pressRelease.attachment_press_release
      );
      formData.append(
        "press_release_content",
        this.pressRelease.press_release_content
      );
      formData.append("is_delete", this.delete);
      let pressReleaseID = this.$route.params.id;
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          axios
            .put(
              `${this.domain}/v1/press_release/${pressReleaseID}`,
              formData,
              {
                headers: {
                  Authorization: this.token,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
              // JSON responses are automatically parsed.
              Swal.fire({
                icon: "success",
                title: `Press Release Data Deleted`,
                showConfirmButton: false,
                timer: 2000,
              });
              this.items = response.data;
              this.$router.push({ path: `/about-us/press-release` });
            })
            .catch((err) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: err.response.data.message.id,
              });
              console.log(err);
            });
        }
      });
    },
    validator(val) {
      return val ? val.length >= 4 : false;
    },
  },
};
</script>

<style scoped>
@import "./PressRelease.css";
</style>
